module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//6.jpg?b0af1d09d1a445e8e056949598d368d6";